import PropTypes from 'prop-types';

import InfoStepperDesktop from './InfoStepperDesktop';
import InfoStepperMobile from './InfoStepperMobile';

const InfoStepper = ({ activeStepIdx, steps = [] }) => (
  <>
    <InfoStepperDesktop activeStepIdx={activeStepIdx} steps={steps} />
    <InfoStepperMobile activeStepIdx={activeStepIdx} steps={steps} />
  </>
);

InfoStepper.propTypes = {
  activeStepIdx: PropTypes.number,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.node,
      subtitle: PropTypes.node,
      description: PropTypes.node,
      imageSrc: PropTypes.string,
    })
  ),
};

export default InfoStepper;
